{
  "Administrator": "Administrador:",
  "AdministratorRole": "Função de administrador:",
  "AdministratorLanguage_ServiceNotification": "Notificação de serviço:",
  "AdministratorLanguage_ConcurrentSignins": "Logins simultâneos permitidos:",
  "NAME": "AdministratorLanguage"
}